"use client"

import { AnimatePresence, motion } from "framer-motion";
import { useTranslations } from "next-intl";
import { useState } from "react";

export default function ResetModal({ isOpen, onClose, onConfirm }) {
    const t = useTranslations('wizard.reset');
    const [isResetting, setIsResetting] = useState(false);

    const handleStorageClear = async () => {
        setIsResetting(true);

        try {
            // Clear app localStorage (not all localStorage)
            localStorage.removeItem('book-pro-storage');

            // Call the onConfirm callback to trigger resetForm
            if (onConfirm) {
                onConfirm();
            }

            // Close modal and reload
            onClose();
            window.location.reload();
        } catch (error) {
            console.error('Error during reset:', error);
            setIsResetting(false);
        }
    };

    return (
        <AnimatePresence>
            {isOpen && (
                <motion.div
                    className="fixed inset-0 z-50 flex items-center justify-center bg-black/10 backdrop-blur-sm"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0 }}
                    onClick={onClose}
                >
                    <motion.div
                        initial={{ scale: 0.95, opacity: 0 }}
                        animate={{ scale: 1, opacity: 1 }}
                        exit={{ scale: 0.95, opacity: 0 }}
                        className="bg-white rounded-[5px] w-full max-w-[520px] mx-4 p-4 text-center shadow-[0px_0px_3px_1px_rgba(0,0,0,0.15)] text-[#2B2B2B]"
                        onClick={(e) => e.stopPropagation()}
                    >
                        <div className="flex justify-end cursor-pointer" onClick={onClose}>
                            <svg width="13" height="12" viewBox="0 0 13 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <line x1="1.3656" y1="10.7758" x2="11.5694" y2="0.571964" stroke="#8F8F8F" strokeWidth="1.21982" />
                                <line x1="1.43127" y1="0.574586" x2="11.6351" y2="10.7784" stroke="#8F8F8F" strokeWidth="1.21982" />
                            </svg>
                        </div>
                        <div className="flex flex-col items-center gap-4 md:text-[18px] font-medium mt-2">
                            <div className="flex flex-col items-center">
                                <p>{t('confirmTitle')}</p>
                                <p>{t('confirmMessage')}</p>
                            </div>

                            <div className="flex gap-4 my-6 font-semibold text-base">
                                <button
                                    onClick={onClose}
                                    disabled={isResetting}
                                    className="bg-white text-orange  w-[140px] h-[46px] rounded-[12px]  justify-center flex items-center shadow-[0px_1.02px_8.12px_4.06px_rgba(130,130,130,0.17)] select-none"
                                >
                                    {t('cancel')}
                                </button>

                                <button
                                    onClick={handleStorageClear}
                                    disabled={isResetting}
                                    className="bg-orange text-white font-semibold w-[145px] h-[46px] rounded-[12px] justify-center flex items-center gap-2 shadow-[0px_1.02px_8.12px_4.06px_rgba(130,130,130,0.17)] select-none"
                                >
                                    {isResetting ? (
                                        <div className="animate-spin rounded-full h-5 w-5 border-t-2 border-white"></div>
                                    ) : t('yesReset')}
                                </button>
                            </div>
                        </div>
                    </motion.div>
                </motion.div>
            )}
        </AnimatePresence>
    )
}